function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgQuotesUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 39.85 35.17"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M385.16 1124a16.25 16.25 0 0 1 2 8 20.3 20.3 0 0 1-5 13.76 32.23 32.23 0 0 1-12 8.72l-1.89-3.23v-.9a13 13 0 0 0 4.72-3.15 18.56 18.56 0 0 0 3.87-5.58 15.61 15.61 0 0 0 1.48-6.56 9.62 9.62 0 0 0-1.39-5.26 5.31 5.31 0 0 0-3.83-2.57l.28-1.62 5.75-6.29a9.37 9.37 0 0 1 6.01 4.68Zm20.95 0a16.25 16.25 0 0 1 2 8 20.29 20.29 0 0 1-5 13.76 32.27 32.27 0 0 1-12 8.72l-1.89-3.23v-.9a13 13 0 0 0 4.73-3.15 18.71 18.71 0 0 0 3.86-5.58 15.63 15.63 0 0 0 1.49-6.56 9.63 9.63 0 0 0-1.4-5.26 5.29 5.29 0 0 0-3.82-2.57l.27-1.62 5.76-6.29a9.37 9.37 0 0 1 6 4.68Z",
  transform: "translate(-368.25 -1119.33)",
  style: {
    fill: "#3cc"
  }
}));

export default SvgQuotesUp;